import { parse } from 'date-fns';
import { afterMonths } from '@/utils/time';
import dateFormatType from '@/constants/dateFormatType';
export default {
    getterStoreAdjustmentListTotal: ({ paginationData }) => paginationData.total,
    getterPageSize: ({ filterOption }) => filterOption.pageSize,
    getterSearchWord: ({ filterOption }) => filterOption.searchWord.value,
    getterSelectedMonth: ({ filterOption }) => filterOption.selectedMonth,
    /**
     * selectedMonth를 한달 기간의 timestamp로 변경
     * @param {Object} state
     * @returns {Array}
     */
    getterSelectedMonthToTimeStamp: ({ filterOption }) => {
        const dateFormat = dateFormatType.MONTH;
        const dateObject = new Date();
        const selectedMonth = parse(filterOption.selectedMonth, dateFormat, dateObject);
        // local time -> epoch time기준으로 변경하기, 10월 조회 시 22-10-01 AM 12:00:00 - 22-10-31 PM 11:59:59.999 보내기
        // epoch time으로 보내면 서버에서 바로고 타임존으로 변경해줌
        return [
            selectedMonth.setHours(9, 0, 0, 0),
            afterMonths(selectedMonth, 1).setHours(8, 59, 59, 999),
        ];
    },
    getterStoreAdjustmentList: ({ list }) => list ?? [],
    getterPaginationData: ({ paginationData }) => {
        const { pageNumber, pages } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
};
